/** 首次任务奖励支持的 Agent。 */
export type FirstTaskRewardAgentType = 'NOVELTY_SEARCH' | 'FTO_SEARCH' | 'DESIGN_FTO_SEARCH';

/** 首次任务奖励支持的动作。 */
export type FirstTaskRewardAction = 'EXPORT' | 'SHARE';

/** 领取接口公开状态。 */
export type FirstTaskRewardClaimStatus = 'GRANTED' | 'ALREADY_GRANTED' | 'PROCESSING';

/** 首次任务奖励领取请求。 */
export interface FirstTaskRewardClaimRequest {
    /** 报告任务 ID。 */
    task_id: string;
    /** 报告所属 Agent。 */
    agent_type: FirstTaskRewardAgentType;
    /** 成功完成的奖励动作。 */
    action: FirstTaskRewardAction;
}

/** 首次任务奖励领取响应。 */
export interface FirstTaskRewardClaimResponse {
    /** 领取状态。 */
    status: FirstTaskRewardClaimStatus;
    /** 奖励积分数量。 */
    credits: number;
    /** 到账时间，毫秒时间戳。 */
    granted_at?: number;
    /** 到期时间，毫秒时间戳。 */
    expires_at?: number;
}

/** 首次任务奖励 API。 */
export interface FirstTaskRewardApi {
    /** 领取首次完成报告奖励。 */
    claim(request: FirstTaskRewardClaimRequest): Promise<FirstTaskRewardClaimResponse>;

    /** 在测试环境重置当前账号的赠送状态。 */
    reset(): Promise<void>;
}

export const FirstTaskRewardApi = Symbol('FirstTaskRewardApi');
